import { EventProperties } from '@asurion-core/analytics-core';
import { redactPii } from '@asurion-core/pii-redaction';
import { FullStory, isInitialized } from '@fullstory/browser';
import { isClient } from './isClient';

const isFullStoryInitialized = () => isClient() && isInitialized();

const isFullStorySessionActive = () =>
  isFullStoryInitialized() && FullStory('getSession', { format: 'url' });

export const startFullStoryRecording = () => {
  if (
    isFullStoryInitialized() &&
    process.env.NEXT_PUBLIC_STAGE !== 'dev' &&
    !FullStory('getSession', { format: 'url' })
  ) {
    FullStory('start');
  }
};

export const getFullStorySessionURL = (): string | undefined =>
  isFullStoryInitialized()
    ? (FullStory('getSession', { format: 'url' }) ?? undefined)
    : undefined;

export const trackEventsInFullStory = (
  eventName: string,
  analyticsProps = {},
) => {
  try {
    if (isFullStorySessionActive()) {
      FullStory('trackEventAsync', {
        name: eventName,
        properties: redactPii(
          analyticsProps as Record<string, unknown>,
        ) as EventProperties,
      });
    }
  } catch (error) {}
};
